
const cancelSubscribe = {
    portugues: {
        msgWaiting: 'Aguarde o processamento...',
        cancelFailedText1: 'Prezado',
        cancelFailedText2: '<b>Atenção:</b> por alguma razão, sua assinatura ainda NÃO FOI CANCELADA!',
        cancelFailedText3: 'Para fazer seu cancelamento, por favor entre em contato conosco: <b>contato@belladasemana.com.br</b>',
        cancelConfirmedText1: 'Prezado',
        cancelConfirmedText2: 'O cancelamento da renovação automática foi efetuado com sucesso.',
        cancelConfirmedText3: 'Seu acesso ao conteúdo exclusivo do Bella da Semana estará ativo até o final de seu plano vigente, em',
        cancelConfirmedText4: 'Esperamos ter correspondido às suas expectativas.',
        cancelConfirmedText5: 'Desejamos que você retorne em breve.',
    },
    ingles: {
        msgWaiting: 'Wait for processing...',        
        cancelFailedText1: 'Dear',
        cancelFailedText2: "<b>Warning:</b> your membership HASN'T BEEN CANCELLED YET!",
        cancelFailedText3: 'In order to proceed, please contact us so we can help you even further: <b>contato@belladasemana.com.br</b>',
        cancelConfirmedText1: 'Dear',
        cancelConfirmedText2: 'Your membership has been successfully canceled.',
        cancelConfirmedText3: 'Your free access to Bella Club’s exclusive content remains active until the end of your current plan, on',
        cancelConfirmedText4: 'We hope you have enjoyed your stay.',
        cancelConfirmedText5: 'We wish to see you back soon!',
    }
  }
  
  export default cancelSubscribe
  